import { Checkbox as HeroUiCheckbox } from '@heroui/checkbox';

export const Checkbox = HeroUiCheckbox;
